import { Stack } from '@mui/material';
import StoreBanners from './banners/StoreBanners';
import StoreHomeHeader from './components/StoreHomeHeader';
import StoreConnectionsSection from './connections/StoreConnectionsSection';

const StoreHome = () => (
  <Stack spacing={4} useFlexGap sx={{ p: { xs: 1, md: 3.75 }, py: { xs: 2, md: 3.75 } }}>
    <StoreHomeHeader />
    <StoreConnectionsSection />
    <StoreBanners />
  </Stack>
);

export default StoreHome;
